
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface ModernFeatureCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  className?: string;
  iconClassName?: string;
  iconBackground?: string;
}

const ModernFeatureCard = ({ 
  title, 
  description, 
  icon: Icon, 
  className,
  iconClassName = "h-6 w-6 text-nation-purple",
  iconBackground = "bg-nation-purple/10"
}: ModernFeatureCardProps) => {
  return (
    <div className={cn(
      "bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 border border-gray-100 dark:border-gray-700 hover:shadow-xl hover:-translate-y-1 transition-all duration-300",
      className
    )}>
      <div className={cn("h-14 w-14 rounded-full flex items-center justify-center mb-5", iconBackground)}>
        <Icon className={iconClassName} />
      </div>
      <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-white">{title}</h3>
      <p className="text-muted-foreground leading-relaxed">{description}</p>
    </div>
  );
};

export default ModernFeatureCard;
